import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const initialState = {
    isLoading: false,
    data: [],
    isError: false,
};

export const fetchApiUsers = createAsyncThunk('fetchUsers', async () => {
    const response = await fetch(`${API_BASE_URL}/api_user/list`, {
        method: 'GET',
        headers: { 'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`) }
    });
    return response.json();
});

export const deleteApiUser = createAsyncThunk('deleteUser', async ({id}, {dispatch}) => {
    const details = {
        'api_user_id': id,
    };

    let formBody = [];
    for (let property in details) {
    let encodedKey = encodeURIComponent(property);
    let encodedValue = encodeURIComponent(details[property]);
    formBody.push(encodedKey + "=" + encodedValue);
    }
    formBody = formBody.join("&");

    
    const response = await fetch(`${API_BASE_URL}/api_user/delete`, {
        method: 'POST',
        headers: { 
            'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        },
        body: formBody
    });
    dispatch(fetchApiUsers());
    return response.json(); 
});

const apiUserSlice = createSlice({
    name: 'apiUser',
    initialState,
    extraReducers: (builder) => {
        builder.addCase(fetchApiUsers.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(fetchApiUsers.fulfilled, (state, action) => {
            state.isLoading = false;
            if(action.payload.data) {
                state.data = action.payload.data;
            } else {
                state.isError = true;
            }
        });
        builder.addCase(fetchApiUsers.rejected, (state, action) => {
            state.isError = true;
            state.isLoading = false;
        })
    }
});

export default apiUserSlice;
